import { useEffect, useState } from "react"
import Link from "next/link"
import { useRouter } from "next/router"
import { apiLiveScore, apiPayment } from "api"
import IconGift from "assets/icon/iconGift"
import IconRouter from "assets/icon/iconRouter"
import IconTelevisionSimple from "assets/icon/iconTelevisionSimple"
import IconTrophy from "assets/icon/iconTrophy"
import IconTurbine from "assets/icon/iconTurbine"
import IconDiamond from "assets/icon/iconDiamond"
import IconGamepad from "assets/icon/iconGamepad"
import IconMusic from "assets/icon/iconMusic"
import IconGolf from "assets/icon/iconGolf"
import IconSport2 from "assets/icon/iconSport2"
import IconSport1 from "assets/icon/iconSport1"
import IconSport from "assets/icon/iconSport"
import IconCalendar from "assets/icon/iconCalendar"
import Image from "next/image"
import { getAccessToken } from "lib/Cookies"
import useStore from "components/ui/Context"
import { notification } from "components/ui"
export default function NavbarMobile({ isNav, setIsNav }) {
  const router = useRouter()
  const [index, setIndex] = useState("/")
  const [subjects, setSubjects] = useState([])
  const [listSub, setListSub] = useState([])
  const { userInfo } = useStore()

  async function fetchMySub() {
    try {
      const { data, success } = await apiPayment.getMySub()
      if (success) {
        const listIdSub = data?.map((sub) => sub?.package?.subs_id).join(",")
        setListSub(listIdSub)
      }
    } catch (error) {
      notification.error({ message: error })
    }
  }

  useEffect(() => {
    if (getAccessToken()) {
      fetchMySub()
    } else {
      setListSub("")
    }
  }, [userInfo])

  useEffect(() => {
    setIndex(router.asPath)
  }, [router])

  useEffect(() => {
    const fetch = async () => {
      if (listSub?.length > 0) {
        const { data } = await apiLiveScore.getSubjects({
          package_ids: listSub
        })
        setSubjects(data)
      } else {
        const { data } = await apiLiveScore.getSubjects()
        setSubjects(data)
      }
    }
    fetch()
  }, [listSub])

  useEffect(() => {
    if (isNav) {
      if (document.body.style.overflow !== "hidden") {
        document.body.style.overflow = "hidden"
      }
    }
    return () => {
      document.body.style.overflow = null
      document.body.style.width = null
    }
  }, [isNav])

  const wapperClass = isNav ? "show__sider--mobile" : "hide__sider--mobile"

  return (
    <div
      className={`z-40 inset-0 fixed h-screen shadow ease-in-out duration-300 ${wapperClass}`}
      onClick={(e) => {
        setIsNav(false)
        e.stopPropagation()
      }}
    >
      <div className="flex flex-col h-full w-[255px] bg-[#232323] justify-between px-4 py-6 rounded-r-3xl">
        <div className="flex flex-col gap-1 w-full">
          <div className="flex items-center justify-between">
            <span className="text-base leading-[22px] font-semibold pl-2 text-[#AFAFAF]">KHÁM PHÁ</span>
            <button
              onClick={() => {
                setIsNav(false)
              }}
              className="hover:bg-[#2E2E2E] rounded-xl p-1.5"
            >
              <img src="/icons/iconArrowExpand.svg" />
            </button>
          </div>

          {subjects.map((item) => {
            return (
              <Link href={`/subject?id=${item.id}`} key={item.id} onClick={() => setIndex(`/subject?id=${item.id}`)}>
                <div
                  className={`flex w-full rounded-xl gap-2 p-2 items-center cursor-pointer hover:bg-[#2E2E2E] text-[#FAFAF9] text-lg ${
                    index === `/subject?id=${item.id}` ? "font-medium text-primary" : ""
                  }`}
                >
                  {item.icon.toLowerCase().includes("gift") && (
                    <IconGift color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("router") && (
                    <IconRouter color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("televisionsimple") && (
                    <IconTelevisionSimple color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("trophy") && (
                    <IconTrophy color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("turbine") && (
                    <IconTurbine color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("dimond_alt") && (
                    <IconDiamond color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("games") && (
                    <IconGamepad color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("music") && (
                    <IconMusic color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("golf") && (
                    <IconGolf color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  )}
                  {item.icon.toLowerCase().includes("sport-2") ? (
                    <IconSport2 color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  ) : item.icon.toLowerCase().includes("sport-1") ? (
                    <IconSport1 color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  ) : item.icon.toLowerCase().includes("sport") ? (
                    <IconSport color={index === `/subject?id=${item.id}` ? "#1877F2" : "#FAFAF9"} />
                  ) : null}
                  <span>{item.name}</span>
                </div>
              </Link>
            )
          })}

          <Link href={`/schedule`} onClick={() => setIndex("schedule")}>
            <div
              className={`flex w-full rounded-xl gap-2 p-2 items-center cursor-pointer hover:bg-[#2E2E2E] text-[#FAFAF9] text-lg ${
                index === "/schedule" ? "font-medium text-primary" : ""
              }`}
            >
              {index === "/schedule" ? <IconCalendar color={"#1877F2"} /> : <IconCalendar color={"#D6D6D6"} />}
              <span>Lịch thi đấu</span>
            </div>
          </Link>
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xs text-[#FFFFFF61]">Tải ứng dụng tại:</span>
          <div className="flex gap-2">
            <div className="fix_img">
              <Image width={90} height={90} src={"/QRCodeONLiveTV.png"} />
            </div>
            <div className="flex flex-col justify-between max-[300px]:hidden">
              <Link href="https://apps.apple.com/vn/app/onlivetv/id6505140172" target="_blank" rel="noreferrer">
                <Image
                  width={125}
                  height={41}
                  src="https://stvinaprod.vtvcab.vn/91af4b21-6541-4aac-b557-eedde81a0f0a.png"
                />
              </Link>
              <div>
                <Link
                  href="https://play.google.com/store/apps/details?id=vn.vtvlive.ontv.a"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Image
                    width={125}
                    height={41}
                    src="https://stvinaprod.vtvcab.vn/3c3bd6a8-bf15-48ab-9bcb-ec12ced5598e.png"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
